export const CREATE_TEMPLATE = 'CREATE_TEMPLATE';
export const FETCH_TEMPLATES = 'FETCH_TEMPLATES';
export const FETCH_TEMPLATE = 'FETCH_TEMPLATE';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const UPDATE_TEMPLATE = 'EDIT_TEMPLATE';